// Web stub for react-native-permissions
export const RESULTS = {
  UNAVAILABLE: 'unavailable',
  DENIED: 'denied',
  LIMITED: 'limited',
  GRANTED: 'granted',
  BLOCKED: 'blocked',
}
export const PERMISSIONS = { IOS: {}, ANDROID: {}, WINDOWS: {} }

export const check = async () => RESULTS.GRANTED
export const request = async () => RESULTS.GRANTED
export const checkMultiple = async (perms = []) =>
  Object.fromEntries((perms || []).map((p) => [p, RESULTS.GRANTED]))
export const requestMultiple = async (perms = []) =>
  Object.fromEntries((perms || []).map((p) => [p, RESULTS.GRANTED]))
export const checkNotifications = async () => ({
  status: RESULTS.GRANTED,
  settings: {},
})
export const requestNotifications = async () => ({
  status: RESULTS.GRANTED,
  settings: {},
})
export const openSettings = async () => {}
export const openLimitedPhotoLibraryPicker = async () => {}

export default {
  RESULTS,
  PERMISSIONS,
  check,
  request,
  checkMultiple,
  requestMultiple,
  checkNotifications,
  requestNotifications,
  openSettings,
  openLimitedPhotoLibraryPicker,
}
